import React from 'react'
import BlogpostList from '../Components/BlogPosts/BlogpostList'
import Pagination from '../Components/Pagination'

function Blog() {
  return (
    <>
      <BlogpostList/>
        
    </>
  )
}

export default Blog